import { flattenObject } from '../lib/flattenObject';

import en from './en.json';

export const code = 'en';
export const stringLocale = flattenObject(en) as Record<string, string>;
export const dateLocale = null;
